<template>
    <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
        <li class="m-menu__section">
            <h4 class="m-menu__section-text">
                AVAILABLE SERVICES
            </h4>
            <i class="m-menu__section-icon flaticon-more-v3"></i>
        </li>
      <li class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
        <router-link :to="{ name: 'services' }" class="m-menu__link m-menu__toggle">
          <i class="m-menu__link-icon fa fa-dashboard"></i>
          <span class="m-menu__link-text">
                    Dashboard
                </span>
        </router-link>
      </li>
        <li v-for="(service,index) in services" :key="index" class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
            <router-link :to="{ name: servicesConfig[service.name].routeName }" class="m-menu__link m-menu__toggle">
                <i class="m-menu__link-icon fa " :class="servicesConfig[service.name].icon"></i>
                <span class="m-menu__link-text">
                    {{ servicesConfig[service.name].name}}
                </span>
            </router-link>
        </li>
    </ul>
</template>
<script>
import servicesConfig from "../../config/services";

export default {
  name: "servicesnav",
  data() {
    return {
      servicesConfig: servicesConfig
    };
  },
  computed: {
    services() {
      return this.$store.state.services;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/partials/ServicesNav.vue